import React from "react";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import { IStyleSet, ILabelStyles, Pivot, PivotItem } from "@fluentui/react";
import CRUDStudentPath from "../CRUD/CRUDStudentPath";
import StudentNewPath from "./StudentNewPath";
import { useTranslation } from "react-i18next";

export default function NewStudent() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardContent>
        <Pivot aria-label={t("students.newStudentPivotLabel")}>
          <PivotItem
            headerText={t("topbar.newStudent")}
            headerButtonProps={{
              "data-order": 1,
              "data-title": t("topbar.newStudent"),
            }}
          >
            <CardHeader title={t("students.createAndEnrollNew")} />
            <CardContent>
              <CRUDStudentPath sm={6} xs={12} md={6} />
            </CardContent>
          </PivotItem>
          <PivotItem headerText={t("students.existingStudent")}>
            <CardHeader title={t("students.enrollExisting")} />
            <CardContent>
              <StudentNewPath sm={6} xs={12} md={6} />
            </CardContent>
          </PivotItem>
        </Pivot>
      </CardContent>
    </Card>
  );
}
